import React from 'react';
import { useParams } from 'react-router-dom';
import { Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetCargo } from 'api/cargos/use-get-cargo.ts';
import { ECommentEntityName } from 'types/comment.ts';
import { CargoAddressesSidebarCard } from 'components/cargos/cargo-addresses-sidebar-card';
import { CargoMain } from 'components/cargos/cargo-main';
import { CargoPageHeader } from 'components/cargos/cargo-page-header';
import { CargoStatistics } from 'components/cargos/cargo-statistics';
import { ClientInfoCard } from 'components/clients/client-info-card';
import { CommentsCard } from 'components/comments/comments-card';

export const CargoPage: React.FC = () => {
  const { cargoId } = useParams();

  const { data: cargo, isLoading } = useGetCargo(Number(cargoId));

  const header = !isLoading && cargo ? <CargoPageHeader cargo={cargo} /> : undefined;

  return (
    <DefaultPageLayout header={header}>
      {!isLoading && cargo ? (
        <>
          <Row gutter={16}>
            <Col span={17}>
              <Flex gap='middle' vertical>
                <CargoStatistics cargo={cargo} />
                <CargoMain cargoId={cargo.id} cargoType={cargo.type} />
              </Flex>
            </Col>
            <Col span={7}>
              <Flex gap='middle' vertical>
                <CargoAddressesSidebarCard cargo={cargo} />
                <ClientInfoCard client={cargo.client} contactId={cargo.order.contactId} />
                <CommentsCard entityName={ECommentEntityName.cargo} entityId={cargo.id} />
              </Flex>
            </Col>
          </Row>
        </>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
